<style scoped lang="scss">

</style>

<template>
  <div>
    <Head title="Leads" />
    <h1 class="mb-8 is-size-3 has-text-weight-bold">Leads</h1>
<!--    <div class="is-flex is-justify-content-flex-end mb-6 is-fullwidth">-->
<!--      <Link class="button is-info" href="/leads-form">-->
<!--        <span>Create</span>-->
<!--        <span class="hidden md:inline">&nbsp;Lead</span>-->
<!--      </Link>-->
<!--    </div>-->
    <card-component>
      <b-table
        striped
        backend-filtering
        backend-pagination
        backend-sorting
        @sort="onSort"
        :data="leads.data">
<!--      <b-table :data="sectorTarget.leads">-->

        <b-table-column label="Contact" sortable searchable field="contact">
          <template #searchable="{filters, column}">
            <b-input v-model="filters[column.field]" @input="search(filters)" placeholder="Search Contacts..."></b-input>
          </template>
          <template #default="{row}">
            <Link :href="`/sector-targets/${row.sector_target.id}/leads/${row.id}`">{{ row.contact.first_name }} {{ row.contact.last_name }}</Link>
          </template>
        </b-table-column>

        <b-table-column label="Subject" sortable searchable field="subject">
          <template #searchable="{filters, column}">
            <b-input v-model="filters[column.field]" @input="search(filters)" placeholder="Search Subjects..."></b-input>
          </template>
          <template #default="{row}">
            <Link :href="`/sector-targets/${row.sector_target.id}/leads/${row.id}`">{{ row.request_title }}</Link>
          </template>
        </b-table-column>

        <b-table-column label="Created" v-slot="{ row }" sortable field="created_at">
          {{ row.created_at | moment }}
        </b-table-column>
      </b-table>

      <laravel-pagination :data="leads" :filter="filters"></laravel-pagination>
    </card-component>
  </div>
</template>

<script>
import CardComponent from '@/Shared/CardComponent.vue'
import LaravelPagination from '@/Shared/LaravelPagination.vue'
import debounce from 'lodash/debounce'
import _ from 'lodash'

export default {
  components: {LaravelPagination, CardComponent},
  props: {
    leads: Object,
    filters: Object,
  },
  methods: {
    update: debounce(function(filters) {
      this.$inertia.get(this.leads.path, {
        ..._.merge(this.filters, filters),
        page: this.leads.current_page,
      }, {
        preserveState: true,
        replace: true,
      })
    }, 300),
    contact_name(contact){
      return contact.first_name + " " + contact.last_name
    },
    full_address(contact) {
      return [contact.address, contact.city, contact.region, contact.postal_code].join(', ');
    },
    onSort(field, order) {
      this.update({ sort_field: field, sort_order: order});
    },
    search(filters) {
      this.update(filters);
    },
  }
}
</script>
